import React from 'react';
import Swal from 'sweetalert2';
import { LogOut as LogOutIcon } from 'lucide-react';
import { TooltipRoot, TooltipContent, TooltipTrigger } from './ui/tooltip';

const LogOut = () => {
  const handleLogout = (event) => {
    event.preventDefault();
    Swal.fire({
      title: 'Authentication Disabled',
      text: 'Logout is disabled in this version. The app runs without authentication.',
      icon: 'info',
      showCloseButton: true
    });
  };

  return (
    <TooltipRoot>
      <TooltipTrigger asChild>
        <a
          href="#"
          onClick={handleLogout}
          className="hover:opacity-80"
          style={{ marginLeft: '10px', display: 'inline-block' }}>
          <LogOutIcon className="w-4 h-4" />
        </a>
      </TooltipTrigger>
      <TooltipContent>Sign out (disabled)</TooltipContent>
    </TooltipRoot>
  );
};

export default LogOut;
